import cookies from '../../utils/cookies';

function parseJwt(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join(''),
  );

  return JSON.parse(jsonPayload);
}

export default {
  authorizeRoute: ({ commit }, isAuthorized) => {
    commit('SET_IS_ROUTE_AUTHORIZED', isAuthorized);
  },
  setCurrentUser: ({ commit }, currentUser) => {
    commit('SET_CURRENT_USER', currentUser);
  },
  validateLogged: ({ commit, dispatch }) => {
    const token = cookies.getItem('token');

    if (token && token !== '') {
      commit('SET_IS_LOGGED', token && token !== '');
      const { unique_name: name, role } = parseJwt(token);

      if (role.toLowerCase() === 'admin') {
        commit('SET_IS_ADMIN', true);
      } else {
        commit('SET_IS_ADMIN', false);
      }

      dispatch('setCurrentUser', { name, isCompany: role === 'Company', isAdmin: role === 'Admin' });
    } else {
      commit('SET_IS_LOGGED', false);
    }
  },
  logout: ({ commit, dispatch }) => {
    cookies.removeItem('token');
    commit('SET_IS_ADMIN', false);
    dispatch('setCurrentUser', {});
  },
};
